import type { MockApiFlags } from '../../../environments/environment.model';

/** Serialises mock request bodies for console output (FormData → plain object). */
export function serializeMockRequestBody(body: unknown): unknown {
  if (body == null) {
    return body;
  }
  if (body instanceof FormData) {
    const entries: Record<string, string> = {};
    body.forEach((value, key) => {
      if (value instanceof File) {
        entries[key] = `File(name=${value.name}, size=${value.size}, type=${value.type || 'n/a'})`;
      } else {
        entries[key] = String(value);
      }
    });
    return entries;
  }
  return body;
}

export function logMockApiExchange(input: {
  feature: keyof MockApiFlags;
  method: string;
  requestUrl: string;
  canonicalPath: string;
  requestBody: unknown;
  status: number;
  responseBody: unknown;
}): void {
  const { feature, method, requestUrl, canonicalPath, requestBody, status, responseBody } = input;
  const label = `[Mock API] ${feature} ${method} ${canonicalPath} → ${status}`;

  console.groupCollapsed(label);
  console.log('request', {
    url: requestUrl,
    method,
    body: serializeMockRequestBody(requestBody),
  });
  console.log('response', {
    status,
    body: responseBody,
  });
  console.groupEnd();
}
